import axios from "./axios";

export const fetchSampleText = async (email, category, subCategory) => {
  try {
    const response = await axios.get("/get_sample_text", {
      params: {
        email: email,
        category: category,
        subCategory: subCategory
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};
